import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';

/**
 * PlayerList Component
 * Displays list of players with current player indicator
 *
 * @param {Array} players - Array of player objects with {name, isHost}
 * @param {string} currentPlayer - Name of the active player
 * @param {string} playerName - Current user's name
 */
const PlayerList = ({ players, currentPlayer, playerName }) => {
  const { t } = useLanguage();

  // Split translation for heading and subtitle
  const playersText = t('common.players');
  const [heading, subtitle] = playersText.includes('(')
    ? playersText.split('(').map((part, i) => i === 1 ? `(${part}` : part)
    : [playersText, ''];

  return (
    <div className="players-section">
      {/* Separate heading container for players */}
      <div className="scorecard-heading-container">
        <h2>{heading}</h2>
      </div>
      {subtitle && (
        <span style={{
          display: 'block',
          fontSize: '0.8rem',
          fontWeight: 'normal',
          marginTop: '-0.5rem',
          marginBottom: '0.5rem',
          textAlign: 'center',
          color: '#6b7280'
        }}>
          {subtitle}
        </span>
      )}
      <div className="players-container">
        {players.map((player, index) => (
          <div
            key={index}
            className={`player-badge ${player.name === currentPlayer ? 'current' : ''}`}
          >
            {player.name}
            {player.isHost ? ` ${t('common.host')}` : ''}
            {player.name === playerName ? ` ${t('common.you')}` : ''}
          </div>
        ))}
      </div>
    </div>
  );
};

export default PlayerList;
